/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Portfolio create-dialog field a field rule applies to.
 * @export
 */
export const PortfolioFieldKey = {
    SequenceNumber: 'SEQUENCE_NUMBER',
    ReferenceCurrency: 'REFERENCE_CURRENCY',
    ChargingCurrency: 'CHARGING_CURRENCY',
    Rubrik: 'RUBRIK',
    Details: 'DETAILS',
    SpecialBoEnabled: 'SPECIAL_BO_ENABLED',
    AllocatedBo: 'ALLOCATED_BO',
    ServicingRole: 'SERVICING_ROLE',
    CashAccounts: 'CASH_ACCOUNTS',
    ExternalAccountNumber: 'EXTERNAL_ACCOUNT_NUMBER',
    ExternalAccountType: 'EXTERNAL_ACCOUNT_TYPE',
    Remarks: 'REMARKS',
    LinkType: 'LINK_TYPE',
    LinkedPortfolioId: 'LINKED_PORTFOLIO_ID',
    AdditionalClassification: 'ADDITIONAL_CLASSIFICATION',
    BrNumber: 'BR_NUMBER'
} as const;
export type PortfolioFieldKey = typeof PortfolioFieldKey[keyof typeof PortfolioFieldKey];


export function instanceOfPortfolioFieldKey(value: any): boolean {
    for (const key in PortfolioFieldKey) {
        if (Object.prototype.hasOwnProperty.call(PortfolioFieldKey, key)) {
            if (PortfolioFieldKey[key as keyof typeof PortfolioFieldKey] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PortfolioFieldKeyFromJSON(json: any): PortfolioFieldKey {
    return PortfolioFieldKeyFromJSONTyped(json, false);
}

export function PortfolioFieldKeyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioFieldKey {
    return json as PortfolioFieldKey;
}

export function PortfolioFieldKeyToJSON(value?: PortfolioFieldKey | null): any {
    return value as any;
}

export function PortfolioFieldKeyToJSONTyped(value: any, ignoreDiscriminator: boolean): PortfolioFieldKey {
    return value as PortfolioFieldKey;
}

